import script from "./FeatureSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureSection.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureSection.vue?vue&type=style&index=0&id=6beb2b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6beb2b64"]])

export default __exports__